import * as actionTypes from '../../actionsTypes/Types';


const inititalState = {
    isDataFetch: false,
    userCount:null,
    cvCount:null,
    isError: false,
    error: {}
}

export const userCountReducer = (state = inititalState, action) => {
    switch (action.type){
        case actionTypes.DASHBOARD_COUNT_TABLE_DATA_START: 
            return {
                ...state,
                isDataFetch: true,
                isError: false,
                error: {}
            }
        case actionTypes.DASHBOARD_COUNT_TABLE_DATA_SUCCESS: 
            return {
                ...state,
                isDataFetch: false,
                isError: false,
                userCount: action.payload.userCount,
                cvCount: action.payload.cvCount,
                error: {}
            }

        case actionTypes.DASHBOARD_COUNT_TABLE_DATA_FAILED: 
            return {
                ...state,
                isError: true,
                isDataFetch: false,
                isAdding: false,
                isUpdating: false,
                error: {...action.payload}
            }
        default: 
            return state
    }
}